<div class="progress-bar-wrapper">
    <ngb-progressbar [value]="progressPercentage"></ngb-progressbar>
    <div class="progress-bar-label">
        <span class="float-start">{{ 'payment.time' | translate }}</span>
        <span class="float-end">{{ progressTime }}</span>
    </div>
</div>
